module.exports = __webpack_public_path__ + "img/cpplogo.2a80bdc0.png";